import React from 'react';
import * as Yup from 'yup';
import v4 from 'uuid';
import { parseDateFromFormats } from '../../../utilities/parseDate';
import moment from 'moment';

export const vtparammap = () => ({
    id: v4(),
    PARAM_KEY: "",
    TRANS_TYPE: "",
    uid_update: "",
    uid_create: "",
    dt_update: "",
    cid: null,
    PARAM_VALUE: "",
    segid: null,
    dt_create: "",
    PARENT_GROUP: "",
    param_info: "",
    status: 1
})

Yup.addMethod(Yup.date, 'format', parseDateFromFormats);
export const vtparammapSchema = Yup.object().shape({
});

export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >PARENT GROUP</div>,
        accessor: 'PARENT_GROUP',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'VtParamMap1',
    },
    {
        Header: <div style={{ textAlign: 'left' }} >TRANS TYPE</div>,
        accessor: 'TRANS_TYPE',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'VtParamMap2',
    },
    {
        Header: <div style={{ textAlign: 'left' }} >PARAM GROUP</div>,
        accessor: 'PARAM_GROUP',
        Cell: row => <div className='ellipsisDiv' style={{ textAlign: "left", paddingLeft: "5px", width: '90%' }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'VtParamMap3'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >PARAM KEY</div>,
        accessor: 'PARAM_KEY',
        Cell: row => <div className='ellipsisDiv' style={{ width: '150px', paddingLeft: "8px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'VtParamMap4',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >PARAM VALUE</div>,
        accessor: 'PARAM_VALUE',
        Cell: row => <div className='ellipsisDiv' style={{ textAlign: "left", paddingLeft: "5px", width: '90%' }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'VtParamMap5'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >Date Updated</div>,
        accessor: 'dt_update',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px", }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? moment(row.value).format('YYYY-MM-DD HH:mm:ss') :  ""}</div>,
        classNameGet: 'VtParamMap6'
    },
]